module.exports = __webpack_public_path__ + "img/undraw_completing_re_i7ap.e8ab9928.svg";